import _ from "@lodash";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import React from "react";
import { connect } from "react-redux";
import Planos from "app/Planos/index.json";
import { matchRoutes } from "react-router-config";
import * as Helpers from "app/Core/Helpers";
import { withRouter } from "react-router-dom";
import ComunicadorApp from "../../ComunicadorApp";

class OnboardingToggle extends XAPPComponent {

    render() {
        const { empresa, settings } = this.props;
        const { pathname } = document.location;
        let AFuncionalidade = null;
        let AMatched = [];

        if (!_.isUndefined(settings.route)) {
            if (!_.isUndefined(settings.route[empresa])) {
                AMatched = matchRoutes(settings.route[empresa], pathname);
            }

            if (!_.isUndefined(settings.route["user"]) && AMatched.length < 1) {
                AMatched = matchRoutes(settings.route["user"], pathname);
            }
        }
        var xappRouteParams = { "empresa": empresa };

        if (AMatched.length > 0) {
            AFuncionalidade = AMatched[0].route.help;
        }

        return (
            <React.Fragment>
                {!_.isNull(AFuncionalidade) && Helpers.checkPlano(Planos.help.show, settings) &&
                    <ComunicadorApp
                        gerenciador={"onboarding"}
                        local={AFuncionalidade}
                        empresa={xappRouteParams.empresa}
                    />
                }
            </React.Fragment>
        );
    }
}

function mapStateToProps({ auth }) {
    return {
        settings: auth.user.data.settings,
    };
}

export default withRouter(connect(mapStateToProps)(OnboardingToggle));
